import _ from 'lodash';
import Link from 'next/link';
import React from 'react';
import useSWR from 'swr';

import CommentPopup from 'components/CommentPopup';
import Footer from 'components/Footer';
import MaxWidthContainer from 'components/MaxWidthContainer';
import Menubar from 'components/Menubar';
import MobileTabBar from 'components/MobileTabBar';

import { swrFetcher } from 'utils/api';
import { MixpanelConfig } from 'utils/mixpanelConfig';

import { useAppLaunch } from 'contexts/AppLaunch';
import { NextSeo } from 'next-seo';
const { useState } = React;

export default function Membership() {
  const { notifications } = useAppLaunch();

  const [isCommentModalShow, setIsCommentModalShow] = useState(false);

  const {
    data: { rewards },
  } = useSWR('/api/v2/rewards', (url) => swrFetcher(url), {
    fallbackData: {
      promotion_info: {},
      reward_info: null,
      rewards: [],
      promotions: [],
    },
  });

  return (
    <div>
      <NextSeo
        title="免費成為Sorra會員｜紀錄好物賺積分換美妝好禮 | Sorra"
        description="免費註冊成為Sorra會員，解鎖專屬福利！會員分享美妝使用心得賺取積分，積分可用於兌換品牌美妝產品。會員更可享專屬優惠及個人化搜尋功能。立即加入Sorra會員，享受一系列專屬禮遇！"
      />

      <main>
        <Menubar
          props={{
            homeExtend: false,
            sourceUI: 'About',
          }}
        />

        <div
          className={
            'globals-centerContentsMargin relative' +
            (notifications.length > 0 ? ' withNoti' : '')
          }
        >
          <div
            className="hidden h-[640px] bg-cover bg-center lg:flex"
            style={{ backgroundImage: 'url(/images/loyality-hero.jpg)' }}
          >
            <MaxWidthContainer className="flex items-center">
              <div>
                <div className="text-2xl font-medium text-sorra-gray-800">
                  會員制度
                </div>
                <div className="mt-[24px] text-5xl font-bold leading-[150%] text-sorra-gray-900">
                  成為Sorra會員
                  <br />
                  紀錄好物、交換心得、賺取好禮！
                </div>
              </div>
            </MaxWidthContainer>
          </div>

          <div className="block bg-[#FFF0F2] lg:hidden">
            <MaxWidthContainer className="px-4 pb-[48px] pt-[24px]">
              <div className="text-center text-base font-normal text-sorra-gray-900">
                會員制度
              </div>
              <div
                className="mt-[16px] text-center text-3xl font-bold leading-[150%] text-sorra-gray-900"
                style={{ lineHeight: 150 + '%' }}
              >
                成為Sorra會員
                <br />
                紀錄好物、交換心得、賺取好禮！
              </div>
            </MaxWidthContainer>
            <img
              src="/images/loyality-hero-mobile.png"
              className="w-[787px]"
            ></img>
          </div>

          <MaxWidthContainer className="px-4 pb-[36px] pt-[36px] lg:pb-[96px] lg:pt-[96px]">
            <div className="flex items-center justify-center">
              <div className="">
                <div
                  className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl"
                  style={{ lineHeight: 150 + '%' }}
                >
                  免費註冊 解鎖會員專屬福利
                </div>
                <div className="mt-[24px] text-center text-base font-normal text-sorra-gray-900 lg:mt-[32px] lg:text-xl">
                  與數十萬素人讀者及專家評審共享最真實、無刪減的美妝情報，分享兼賺取美妝好禮！
                </div>
                <div className="mt-[24px] lg:mt-[65px]">
                  <div className="flex w-full flex-wrap place-items-center items-center justify-center gap-x-[40px] gap-y-[40px] lg:gap-x-[100px]">
                    <div className="space-y-[8px] lg:space-y-[16px]">
                      <img
                        className="mx-auto h-[70px] w-[70px] lg:h-[120px] lg:w-[120px]"
                        src="/svgs/loyality-advantage-00.svg"
                      ></img>
                      <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                        解鎖所有內容
                      </div>
                    </div>
                    <div className="space-y-[8px] lg:space-y-[16px]">
                      <img
                        className="mx-auto h-[70px] w-[70px] lg:h-[120px] lg:w-[120px]"
                        src="/svgs/loyality-advantage-01.svg"
                      ></img>
                      <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                        留評價賺積分
                      </div>
                    </div>
                    <div className="space-y-[8px] lg:space-y-[16px]">
                      <img
                        className="mx-auto h-[70px] w-[70px] lg:h-[120px] lg:w-[120px]"
                        src="/svgs/loyality-advantage-02.svg"
                      ></img>
                      <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                        個人化搜尋
                      </div>
                    </div>
                    <div className="space-y-[8px] lg:space-y-[16px]">
                      <img
                        className="mx-auto h-[70px] w-[70px] lg:h-[120px] lg:w-[120px]"
                        src="/svgs/loyality-advantage-03.svg"
                      ></img>
                      <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                        專屬商店優惠
                      </div>
                    </div>
                    <div className="space-y-[8px] lg:space-y-[16px]">
                      <img
                        className="mx-auto h-[70px] w-[70px] lg:h-[120px] lg:w-[120px]"
                        src="/svgs/loyality-advantage-04.svg"
                      ></img>
                      <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                        賺好禮
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-[32px] text-center text-xl font-normal text-sorra-gray-900 lg:mt-[64px]">
                  <button
                    className="h-[48px] w-full rounded-[8px] bg-sorra-pink text-base font-medium text-[#fff] lg:w-[300px]"
                    onClick={() => {
                      MixpanelConfig.track('signinup_from_membership_CTA');
                      window.location.href = '/login';
                    }}
                  >
                    成為會員
                  </button>
                </div>
              </div>
            </div>
          </MaxWidthContainer>

          <div className='bg-[url("/images/loyality-coin-bg-mobile.png")] bg-cover bg-center lg:bg-[url("/images/loyality-coin-bg.png")]'>
            <MaxWidthContainer className="px-4 pb-[36px] pt-[36px] lg:pb-[96px] lg:pt-[96px]">
              <div className="flex items-center justify-center">
                <div className="w-full">
                  <div
                    className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl"
                    style={{ lineHeight: 150 + '%' }}
                  >
                    讓每段美妝體驗都更有價值
                  </div>
                  <div className="mt-[24px] text-center text-base font-normal text-sorra-gray-900 lg:mt-[32px] lg:text-xl">
                    每次妳上載新產品體驗或為產品評分，不但為一眾素人帶來更深度資訊，
                    <br />
                    更會為妳帶來美妝好物！在 Sorra 上載體驗、評分都可賺取積分！
                    <br />
                    <br />每 ✦$1 Sorra 積分直接兑 HK$1 在 Sorra
                    上換領品牌美妝產品。
                  </div>

                  <div className="mx-auto mt-[24px] w-full max-w-[904px] lg:mt-[64px]">
                    <div className="flex rounded-[8px] bg-[#E7E7E7] text-base font-bold text-sorra-gray-900">
                      <div className="flex w-1/2 items-center px-4 py-[12px]">
                        任務
                      </div>
                      <div className="hidden w-1/2 items-center px-4 py-[12px] lg:flex">
                        獲取積分（$1 積分兑 HK$1）
                      </div>
                      <div className="block w-1/2 items-center px-4 py-[12px] lg:hidden">
                        獲取積分
                        <br />
                        <div className="font-normal">$1 積分兑 HK$1</div>
                      </div>
                    </div>
                    <div className="flex border-b-[#E7E7E7] text-base font-medium">
                      <div className="w-1/2 px-4 py-6">註冊帳號</div>
                      <div className="w-1/2 px-4 py-6">✦$5</div>
                    </div>
                    <div className="flex border-b-[#E7E7E7] bg-[#F5F5F5]/50 text-base font-medium">
                      <div className="w-1/2 px-4 py-6">完成追加皮膚檔案</div>
                      <div className="w-1/2 px-4 py-6">✦$25</div>
                    </div>
                    <div className="flex border-b-[#E7E7E7] text-base font-medium">
                      <div className="w-1/2 px-4 py-6">
                        完成產品評價（每週首5則）
                      </div>
                      <div className="w-1/2 px-4 py-6">最高✦$20</div>
                    </div>
                    <div className="flex border-b-[#E7E7E7] bg-[#F5F5F5]/50 text-base font-medium">
                      <div className="w-1/2 px-4 py-6">
                        推薦好友加入 Sorra（最多10個）
                      </div>
                      <div className="w-1/2 px-4 py-6">✦$25</div>
                    </div>
                  </div>
                </div>
              </div>
            </MaxWidthContainer>
          </div>

          <MaxWidthContainer className="px-4 pb-[36px] pt-[36px] lg:pb-[96px] lg:pt-[96px]">
            <div className="flex items-center justify-center">
              <div className="">
                <div
                  className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl"
                  style={{ lineHeight: 150 + '%' }}
                >
                  真正當錢使！
                  <br />
                  $1 積分兑 HK$1 換購品牌美妝
                </div>
                <div className="mt-[24px] lg:mt-[65px]">
                  <div className="grid grid-cols-2 gap-x-[16px] gap-y-[32px] pt-[28px] lg:grid-cols-4 lg:gap-x-[24px] lg:gap-y-[48px] lg:pt-[48px]">
                    {_.take(rewards, 4).map((reward, index) => {
                      const {
                        id,
                        name,
                        en_name,
                        image,
                        score,
                        inventory,
                        brand,
                      } = reward;
                      return (
                        <Link
                          prefetch={false}
                          key={id}
                          href={`rewards/gift/${id}`}
                          className="relative w-auto lg:w-[302px]"
                        >
                          <div className="relative aspect-square w-full rounded-lg bg-gray-50 p-9">
                            <img
                              src={
                                image
                                  ? image.url
                                  : 'images/placeholders/product.png'
                              }
                              alt={image ? image.alternativeText || '' : ''}
                            ></img>
                          </div>
                          <div className="pt-6 text-sm text-sorra-gray-800">
                            {(brand && brand.name) || ''}
                          </div>
                          <div className="pb-[16px] pt-1 text-lg font-medium text-sorra-gray-900">
                            {name || ''}
                            <br />
                            {en_name || ''}
                          </div>
                          <div className="flex">
                            <img
                              src="/svgs/sorra-points-small.svg"
                              className="mr-[8px]"
                            ></img>
                            <div className="text-base font-medium text-sorra-gray-900">
                              {'$' + score || 0}
                            </div>
                          </div>
                          <div
                            className={
                              'mt-[8px] text-xs font-medium text-sorra-gray-800' +
                              (inventory == 0 || inventory >= 2
                                ? ' hidden'
                                : '')
                            }
                          >
                            剩餘最後{' '}
                            <span className="text-sorra-pink">
                              {inventory || 0}
                            </span>{' '}
                            件產品
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                </div>
                <div className="mt-[32px] text-center text-xl font-normal text-sorra-gray-900 lg:mt-[64px]">
                  <button
                    className="h-[48px] w-full rounded-[8px] bg-sorra-pink text-base font-medium text-[#fff] lg:w-[300px]"
                    onClick={() => {
                      window.location.href = '/rewards';
                    }}
                  >
                    換取好禮
                  </button>
                </div>
              </div>
            </div>
          </MaxWidthContainer>

          <div className="bg-[#F5F5F5]">
            <MaxWidthContainer className="px-4 pb-[36px] pt-[36px] lg:pb-[96px] lg:pt-[96px]">
              <div className="flex items-center justify-center">
                <div className="">
                  <div
                    className="text-center text-2xl font-bold leading-[150%] text-sorra-gray-900 lg:text-5xl"
                    style={{ lineHeight: 150 + '%' }}
                  >
                    2 分鐘完成註冊 即時解鎖會員福利！
                  </div>
                  <div className="mt-[24px] lg:mt-[65px]">
                    <div className="flex w-full flex-wrap place-items-center items-center justify-center gap-x-[34px] gap-y-[40px] lg:gap-x-[94px]">
                      <div className="w-[146px] space-y-[12px] lg:w-[180px] lg:space-y-[24px]">
                        <img
                          className="mx-auto h-[100px] w-[100px] lg:h-[120px] lg:w-[120px]"
                          src="/svgs/loyality-register-00.svg"
                        ></img>
                        <div>
                          <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                            第 1 步
                          </div>
                          <div className="text-center text-xl font-bold text-sorra-gray-900 lg:text-2xl">
                            免費註冊
                          </div>
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                          所有資料保密，
                          <br />
                          無滋擾聯絡。
                        </div>
                      </div>
                      <div className="w-[146px] space-y-[12px] lg:w-[180px] lg:space-y-[24px]">
                        <img
                          className="mx-auto h-[100px] w-[100px] lg:h-[120px] lg:w-[120px]"
                          src="/svgs/loyality-register-01.svg"
                        ></img>
                        <div>
                          <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                            第 2 步
                          </div>
                          <div className="text-center text-xl font-bold text-sorra-gray-900 lg:text-2xl">
                            完成皮膚檔案
                          </div>
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                          於會員專區完成
                          <br />
                          「詳細皮膚檔案」
                          <br />
                          獲取額外積分。
                        </div>
                      </div>
                      <div className="w-[146px] space-y-[12px] lg:w-[180px] lg:space-y-[24px]">
                        <img
                          className="mx-auto h-[100px] w-[100px] lg:h-[120px] lg:w-[120px]"
                          src="/svgs/loyality-register-02.svg"
                        ></img>
                        <div>
                          <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                            第 3 步
                          </div>
                          <div className="text-center text-xl font-bold text-sorra-gray-900 lg:text-2xl">
                            留評價賺積分
                          </div>
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                          分享你的美妝體驗，
                          <br />
                          留評價賺取積分！
                        </div>
                      </div>
                      <div className="w-[146px] space-y-[12px] lg:w-[180px] lg:space-y-[24px]">
                        <img
                          className="mx-auto h-[100px] w-[100px] lg:h-[120px] lg:w-[120px]"
                          src="/svgs/loyality-register-03.svg"
                        ></img>
                        <div>
                          <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                            第 4 步
                          </div>
                          <div className="text-center text-xl font-bold text-sorra-gray-900 lg:text-2xl">
                            積分好禮 Get！
                          </div>
                        </div>
                        <div className="text-center text-base font-normal text-sorra-gray-900 lg:text-xl">
                          ✦$1 Sorra 積分兌 HK$1，換取品牌好物。
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-[32px] text-center text-xl font-normal text-sorra-gray-900 lg:mt-[64px]">
                    <button
                      className="h-[48px] w-full rounded-[8px] bg-sorra-pink text-base font-medium text-[#fff] lg:w-[300px]"
                      onClick={() => {
                        MixpanelConfig.track('signinup_from_membership_CTA');
                        window.location.href = '/login';
                      }}
                    >
                      免費註冊
                    </button>
                  </div>
                </div>
              </div>
            </MaxWidthContainer>
          </div>
        </div>

        <Footer />

        <CommentPopup
          externalPopupShown={isCommentModalShow}
          externalProductID={null}
          externalProductBrandName={null}
          externalProductName={null}
          setExternalPopupShown={setIsCommentModalShow}
        />

        <MobileTabBar props={{ highlighted: 'home' }} />
      </main>
    </div>
  );
}
